<template>
    <router-link :to="{ name: 'cookingCheckInput', params: {menuId:menuId,subMenuId:subMenuId} }">{{lowerButtonName}}</router-link>
</template>

<script>
    export default {
        name: 'CookingMenuButton',
        props: {
            menuId:Number,
            subMenuId:Number,
            lowerButtonName: String,
            upperButtonName:String,
        }
    }
</script>
